import { useQuery } from '@tanstack/react-query';
import ApiService from 'src/services/ApiService';

export const useExternalFields = (sourceType: string) => {
  return useQuery({
    queryKey: ['/external-fields', sourceType] as const,
    queryFn: ApiService.fields.getExternalFields,
  });
};
